import React, { useState, useEffect } from "react";
import TitlePage from "../../Shared/TitlePage";
import { dataService } from "../../../Services/data/data.service";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { dataListTypes, crudTypes, subscriptionTiers } from "../../../Config/constants";
import { Infinity, Plus, Search, Pencil, ReceiptEuro, Link2 } from "lucide-react";
import { parseNewDateToDDMMYYYnoTime } from "../../../Utils/dateHelper";
import { SubscriberFilterTypes } from "../../../Config/constants";
// Components
import Button from "../../Shared/Buttons/Button";
import TabSelector from "../../Shared/ui/TabSelector";
import Tab from "../../Shared/ui/Tab";
// Tabs
import PriceDefinitionTab from "./Components/Tabs/PriceDefinitionTab";
import PriceBundleTab from "./Components/Tabs/PriceBundleTab";
// Dialogs
import PriceAPIDialog from "./Components/PriceAPIDialog";

function FinancialCenterPage(props) {
  const classes = useStyles();

  // General
  const [generalError, setGeneralError] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [userCompanies, setUserCompanies] = useState([]);

  // Price API Dialog
  const [priceAPIDialogOpen, setPriceAPIDialogOpen] = useState(false);

  // Fetch user companies on component mount
  useEffect(() => {
    if (props.Login.userid) {
      dataService
        .getUserAndCompanyData(props.Login.userid)
        .then((result) => {
          if (result) {
            setUserCompanies(result);
          }
        })
        .catch((error) => {
          console.error("Error fetching user companies:", error);
          setGeneralError("Failed to load user companies");
        });
    }
  }, [props.Login.userid]);

  const openPriceAPIDialog = () => {
    setPriceAPIDialogOpen(true);
  };

  const closePriceAPIDialog = () => {
    setPriceAPIDialogOpen(false);
  };

  return (
    <React.Fragment>
      <TitlePage Text="Financial Center" backbutton={true} {...props} />
      <Box
        sx={{
          maxWidth: "90%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          marginRight: "auto",
          marginLeft: "auto",
          marginTop: "120px",
        }}
      >
        <div className={classes.header}>
          <h1>Financial Center</h1>
          <Button size="extraSmall" variant="secondary" startIcon={<Link2 />} onClick={openPriceAPIDialog}>
            Price API
          </Button>
        </div>
        <TabSelector value={selectedTab} onChange={setSelectedTab}>
          <Tab value={0} style={{ width: "7.5rem" }}>
            Price Definitions
          </Tab>
          <Tab value={1} style={{ width: "7.5rem" }}>
            Price Bundles
          </Tab>
          {/* <Tab value={2} style={{ width: "7.5rem" }}>
            Accounts
          </Tab> */}
        </TabSelector>
        {generalError && (
          <div className={classes.errorContainer}>
            <p className={classes.errorMessage}>{generalError}</p>
          </div>
        )}
        {selectedTab === 0 && (
          <div className={classes.tabContentContainer}>
            <PriceDefinitionTab {...props} />
          </div>
        )}
        {selectedTab === 1 && (
          <div className={classes.tabContentContainer}>
            <PriceBundleTab {...props} />
          </div>
        )}
      </Box>

      {/* Price API Dialog */}
      <PriceAPIDialog 
        dialogOpen={priceAPIDialogOpen} 
        closeDialog={closePriceAPIDialog}
        userCompanies={userCompanies}
        {...props} 
      />
    </React.Fragment>
  );
}

export default FinancialCenterPage;

const useStyles = makeStyles({
  header: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: "16px",
    marginBottom: "16px",
  },

  tabContentContainer: {
    width: "100%",
    marginTop: "1rem",
    boxSizing: "border-box",
  },

  errorContainer: {
    width: "100%",
    backgroundColor: "#FDF3F3",

    border: "1px solid #FBE5E5",
    borderRadius: "6px",

    marginBottom: "16px",
    padding: "12px",
  },

  errorMessage: {
    fontSize: "16px",
    color: "#D84949",
  },
});
